import { render, staticRenderFns } from "./ExcursionOrders.vue?vue&type=template&id=0ba0f5bd&"
import script from "./ExcursionOrders.vue?vue&type=script&lang=ts&"
export * from "./ExcursionOrders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports